import { Col, Row, Space, Table } from "antd";
import ReportExcel from "../../api/service/report/reportExcel";
import { ReportCsv } from "../../api/service/report/reportCsv";
import columnAlert from "./table/data.table";

export default function AlertInactive({
  data,
  toggleActive,
  deleteAlert,
  translate,
  t,
  exportFileName,
}) {
  const filteredColumns = columnAlert(toggleActive, deleteAlert, t).filter(
    (col) =>
      col.key !== "active" &&
      col.dataIndex !== "active" &&
      col.key !== "isActive" &&
      col.dataIndex !== "isActive",
  );

  return (
    <div style={{ padding: "0px 0 24px" }}>
      <Row justify="end" style={{ marginBottom: 16 }}>
        <Col>
          <Space wrap>
            <ReportExcel dataSet={translate(data)} fileName={exportFileName} />
            <ReportCsv dataSet={translate(data)} fileName={exportFileName} />
          </Space>
        </Col>
      </Row>

      <Table
        columns={filteredColumns}
        dataSource={data}
        rowKey="uuid"
        scroll={{ x: "max-content" }}
        pagination={{
          pageSize: 10,
          showSizeChanger: true,
          showTotal: (total) => `${t("alerts.total")}: ${total}`,
        }}
      />
    </div>
  );
}
